import styled from 'styled-components';

const PageTitle = styled.h1`
  font-family: Rockwell, serif;
  font-weight: normal;
  text-transform: uppercase;
  margin: 52px auto;
`
export default PageTitle;
